import { Box, Button, Drawer, Tooltip, Typography } from '@mui/material'
import React, { Component } from 'react'
import { Colors } from '../../../Styles/Colors'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import './RadBillTrans.css'
import { AmountsCard } from '../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../Utility/ImagePaths'
import { DataGrid } from '@mui/x-data-grid'
import { DateTime } from 'luxon'
import { AmountFormat, CheckAccessFunc, formatDate, GetInvestigationName, timeOnlyConvert } from '../../../Components/CommonFunctions/CommonFunctions'
import { CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import { CurrencySymbol } from '../../../Utility/Constants'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import RadBillingFilter from './RadBillingFilter'
import { localGetItem, localSetItem, setCachevalue } from '../../../Utility/Services/CacheProviderService'

let isUser = null

export default class RadSavedBills extends Component {
  constructor(props) {
    super(props)
    const savedFilter = JSON.parse(localGetItem('globalDateFilter') || 'null');
    this.state = {
      savedBillsData: [],
      totalBill: 0,
      savedBillAmount: 0,
      page: 0,
      pageSize: 10,
      ref: props.location?.pathname,
      FilterOpen: false,
      FilterDatas: {
        "FromDate": savedFilter?.FromDate || DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        "ToDate": savedFilter?.ToDate || DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        "DateIndex": savedFilter?.DateIndex || 1,
        "PatientName": "",
        "AccNo": "",
        "MobNo": "",
        "DoctorName": [],
        "BillNumber": "",
        "PaidAmount": "",
        "InPatientSelected": true,
        "OutPatientSelected": true,
        "PharmacySelected": true,
        "LaboratorySelected": true,
        "ImageLabSelected": true,
        "OTSelected": true,
        "PaidSelected": true,
        "PartialPaidSelected": true,
        "CreditSelected": true,
        "CardSelected": true,
        "CashSelected": true,
        "UPISelected": true,
        "BankTransferSelected": true,
        "InsuranceSelected": true,
        "ChequeSelected": true,
        "BillType": ['op', 'ip', GetInvestigationName(true)],
        "PayStatus": [],
        "PayMethods": [],
        "startTime": null,
        "endTime": null,
        "BillModuleType": ['op', 'ip', GetInvestigationName(true)],
        "opCreditBills": true,
        "ipCreditBills": true,
        'radiologyCreditBills': true,
        'RadiologyBills': true,
        "RadiologySelected": true

      },
      selectedId: null,
      removeData: false,
      FilterOpen: false
    }
  }

  componentDidMount() {
    isUser = JSON.parse(localGetItem('loggedInUserInfo'))
    this.getSavedBillData()
  }

  getPatientData = (data) => {
    try {
      let { history } = this.props
      RestAPIService.getAll(Serviceurls.FO_PATIENT_UPDATE + '?patient_id=' + data?.patient_id)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              selectedPatientData: response.data.data
            }, () => {
              let PatientData = {
                ...this.state.selectedPatientData,
                ...data
              }
              if (localGetItem("isNewBilling") === "true") {
                setCachevalue(true, 'isForCancelBill')
                setCachevalue(true, 'FromOtherScreen')
                setCachevalue(`/${GetInvestigationName()}BillingTransaction/SavedBills`, 'path')
                history.push({ pathname: `/${GetInvestigationName()}Billing/HospitalBilling`, state: { invoiceId: data?.id, fromPatientSavedBill: true, patientDetails: this.state.selectedPatientData, appointment_id: this.state.selectedPatientData?.appointment_id } })
              } else {
                setCachevalue(JSON.stringify(PatientData), 'RadPatientData')
                this.props.history?.push({ pathname: '/RadiologyHome/Patient/Billing', state: { fromSavedBill: true, billSummaryId: data?.id } })
              }
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getSavedBillData = () => {
    try {
      let states = this.state
      let start_time = states.FilterDatas.startTime ? new Date(states.FilterDatas.startTime) : ''
      let end_time = states.FilterDatas.endTime ? new Date(states.FilterDatas.endTime) : ''
      let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
      let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

      let doctorId = [];
      states.FilterDatas.DoctorName.forEach(element => doctorId.push(element.doctor_id))
      this.LoaderFunction(true)
      const baseUrl = (localGetItem('isNewBilling') === "true") ? (localGetItem('is_investigation_module') === "true" ? Serviceurls.NEW_INVESTIGATION_SAVED_BILL_TRANS_GET : Serviceurls.NEW_RAD_SAVED_BILL_TRANS_GET) : Serviceurls.RAD_SAVED_BILL_TRANS_GET;
      RestAPIService.getAll(baseUrl +
        "?from_date=" + this.state.FilterDatas?.FromDate +
        "&to_date=" + this.state.FilterDatas?.ToDate +
        "&start_time=" + setStartTime +
        "&end_time=" + setEndTime +
        "&patient_name=" + this.state.FilterDatas?.PatientName +
        "&patient_acc_number=" + this.state.FilterDatas?.AccNo +
        "&mobile_number=" + this.state.FilterDatas?.MobNo +
        "&doctor_id=" + doctorId +
        "&bill_number=" + this.state.FilterDatas?.BillNumber
      )
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              savedBillsData: response.data.data,
              totalBill: response?.data?.total_bill,
              totalAmount: response?.data?.total_amount
            }, () => this.LoaderFunction(false))
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
          this.LoaderFunction(false)
        })
    } catch (error) {
      this.errorMessage(error.message)
      this.LoaderFunction(false)
    }
  }

  deleteSavedBillData = () => {
    try {
      this.setState({ removeData: true })
      var data = {}
      const baseUrl = localGetItem('isNewBilling') === "true" ? Serviceurls.NEW_COMPLETE_BILLS_GET : Serviceurls.RAD_SAVED_BILL_GET +'?id=' + this.state.selectedId;
      if(localGetItem('isNewBilling') === "true"){
        data = {
          id: this.state.selectedId,
        }
      }
      RestAPIService.delete(baseUrl, data)
        .then((response) => {
          if (response.data.status === 'success') {
            this.successMessage(response.data.message)
            this.getSavedBillData()
            this.setState({ removeData: false, selectedId: null, deletePopup: false })
          }
        }).catch((error) => {
          this.setState({ removeData: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ removeData: false })
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  onDeleteHandler = (item) => {
    try {
      this.setState({
        deletePopup: true,
        selectedId: item?.id
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  popupClose = () => {
    try {
      this.setState({
        deletePopup: false
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  gridToolBar = () => {
    var { t } = this.props
    let start_time = this.state.FilterDatas.startTime ? new Date(this.state.FilterDatas.startTime) : ''
    let end_time = this.state.FilterDatas.endTime ? new Date(this.state.FilterDatas.endTime) : ''
    let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
    let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

    let TextArray = [
      { label: "From Date", value: formatDate(this.state.FilterDatas.FromDate) },
      { label: "To Date", value: formatDate(this.state.FilterDatas.ToDate) },
    ]
    if (this.state.FilterDatas.startTime !== null && this.state.FilterDatas.endTime !== null) {
      TextArray.push(
        { label: "Start Time", value: timeOnlyConvert(setStartTime) },
        { label: "End Time", value: timeOnlyConvert(setEndTime) }
      )
    }
    return (
      <Box>
        <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
      </Box>
    )
  }

  ClosePopUp(Getapicall = false, message = "") {
    this.setState({
      FilterOpen: false,
      BillPreviewPop: false,
      CreditBillPopUp: false
    }, () => {
      if (Getapicall && message !== "") {
        this.successMessage(message)
      }
    })
  }

  renderFilter = (data) => {
    localSetItem('globalDateFilter', JSON.stringify({FromDate: data?.FromDate, ToDate: data?.ToDate, DateIndex: data?.DateIndex  }))
    this.setState({
      FilterDatas: data,
      FilterOpen: false,
    }, () => { this.getSavedBillData() })
  }

  clearFilter = (data) => {
    this.setState({
      FilterDatas: data
    })
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

   PrintCancelledData(Billid) {
      try {
        RestAPIService.getAll(Serviceurls.NEW_OP_INVOICE_PRINT + `?invoce_id=${Billid}`).
          then((response) => {
            if (response) {
              //Create a Blob from the PDF Stream
              const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
              //Build a URL from the file
              const fileURL = URL.createObjectURL(file);
              //Open the URL on new Window
              window.open(fileURL);
            }
          }).catch((error) => {
            this.errorMessage(error?.message)
          })
      } catch (e) {
        this.errorMessage(e?.message)
      }
    }

  render() {
    this.state.savedBillsData?.forEach((element, index) => element.sno = index + 1)
    const columns = [
      {
        field: 'invoice_date', headerName: 'Date And Time', flex: 0.143, align: 'center', headerAlign: 'center',
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_date_sav'>{params?.row?.invoice_date ? params?.row?.invoice_date : '-'}</Box>)
      },
      {
        field: 'patient_name', headerName: 'Patient Details', flex: 0.111,
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_pat_name_sav'>
          <Typography fontSize={'0.9vw'} fontWeight={600}>{params?.row?.patient_name ?
            params?.row?.patient_name?.length > 10 ?
              <Tooltip placement='top' title={params?.row?.patient_name + " " + params?.row?.patient_age + '/' + params?.row?.patient_gender?.toUpperCase()}>
                <div style={{ fontWeight: 600, fontSize: '0.9vw' }}>{params?.row?.patient_name?.slice(0, 10) + '...' + (params?.row?.patient_age ? params?.row?.patient_age : '-') + '/' + (params?.row?.patient_gender ? params?.row?.patient_gender?.toUpperCase() : '-')}</div>
              </Tooltip> :
              (params?.row?.patient_name + " " + (params?.row?.patient_age ? params?.row?.patient_age : '-') + '/' + (params?.row?.patient_gender ? params?.row?.patient_gender?.toUpperCase() : '-')) : '-'}</Typography>
          <Typography fontSize={'0.8vw'} color={Colors.grayShade}>{params?.row?.patient_acc_number ? params?.row?.patient_acc_number : '-'}</Typography>
        </Box>), valueGetter: (params) => {
          const name = params?.row?.patient_name || "";
          const number = params?.row?.patient_acc_number || "";
          return `${name} ${number}`;
        }
      },
      {
        field: 'module_type', headerName: 'Bill Type', flex: 0.143,
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_bill_type_sav'>{params?.row?.module_type ? params?.row?.module_type : '-'}</Box>)
      },
      {
        field: 'temp_invoice_number', headerName: 'Bill Number', flex: 0.143,
        renderCell: (params) => {
          let BillNumber = "";
          if (params?.row?.temp_invoice_number) { BillNumber = params?.row?.temp_invoice_number }
          return (
            <Tooltip placement='top' title={BillNumber} arrow>
              <Box component={'div'}>{BillNumber ? '...' + BillNumber?.slice(-10) : "-"}</Box>
            </Tooltip>
          )
        }
      },
      {
        field: 'doctor_name', headerName: 'Doctor Name', flex: 0.143,
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_doc_name_sav'>{params?.row?.doctor_name ? params?.row?.doctor_name : '-'}</Box>)
      },
      {
        field: 'net_amount', headerName: `Amount (${CurrencySymbol})`, flex: 0.143, type: 'number',
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_amt_sav'>{AmountFormat(params?.row?.net_amount ? params?.row?.net_amount : 0)}</Box>)
      },
    ]
    if (CheckAccessFunc(GetInvestigationName(), "Billing Transaction", 'Saved Bills', null, "Tab")?.editAccess) {
      columns.push({
        field: 'Action', headerName: 'Action', flex: 0.143, headerAlign: 'center', align: 'center',
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_act_sav'>
          <Tooltip placement='top' title={'Create Bill'} arrow>
            <Button className='Common_Btn_Min_Width' emed_tid='rad_bill_trns_prt_sav' sx={{ height: '1.8vw', visibility:( localGetItem('isNewBilling') === 'true' && params?.row?.ip_admission_id )? 'hidden' : 'visible' }}
              onClick={() => { this.getPatientData(params?.row) }}
            >
              <Box component={'img'} src={ImagePaths.CreateBill.default} height={'1.8vw'} width={'1.8vw'} />
            </Button>
          </Tooltip>
          <Tooltip placement='top' title={'Delete'} arrow>
            <Button className='Common_Btn_Min_Width' emed_tid='rad_bill_trns_prt_sav' sx={{ height: '1.8vw' }}
              onClick={() => this.onDeleteHandler(params?.row)}>
              <Box component={'img'} src={ImagePaths.Delete.default} height={'1.8vw'} width={'1.8vw'} />
            </Button>
          </Tooltip>
          {(localGetItem("isNewBilling") === "true" && localGetItem("print_option_for_draft_bills") === "true") ? <Tooltip placement='top' title={'Print'} arrow>
            <Button className='Common_Btn_Min_Width' emed_tid='rad_bill_trns_prt_sav' sx={{ height: '1.8vw' }}
              onClick={() => {this.PrintCancelledData(params?.row?.id) }}>
              <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'1.8vw'} width={'1.8vw'} />
            </Button>
          </Tooltip> : null}
        </Box>)
      })
    }
    return (
      <Box component={'div'} sx={{ backgroundColor: Colors.Background }}>
        <Box component={'div'} className='rad_bill_trns_container'>
          <Box component={'div'} className='rad_bill_trns_header_card'>
            <Box component={'div'} className='rad_bill_trns_cards'>
              {AmountsCard('Total Bill', this.state.totalBill, true, "white", false, null, 'rad_bill_trns_tlt_bill_sav')}
              {AmountsCard('Total Amount', this.state.totalAmount, false, "white", false, null, 'rad_bill_trns_tlt_amt_sav')}
            </Box>
            <Box component={'div'} className='rad_bill_trns_btns'>
              <Tooltip placement='top' title={'Filter'} arrow>
                <Button className='Common_Btn_Min_Width rad_bill_btn' emed_tid='rad_bill_trns_flt_sav'
                  onClick={() => this.setState({ FilterOpen: true })}
                >
                  <Box component={'img'} src={ImagePaths.Filter.default} height={'2vw'} width={'2vw'} />
                </Button>
              </Tooltip>
              {/* <Tooltip placement='top' title={'Print'} arrow>
                <Button className='Common_Btn_Min_Width rad_bill_btn' emed_tid='rad_bill_trns_prt_sav'>
                  <Box component={'img'} src={ImagePaths.LabPrintIcon.default} height={'2vw'} width={'2vw'} />
                </Button>
              </Tooltip>
              <Tooltip placement='top' title={'Export'} arrow>
                <Button className='Common_Btn_Min_Width rad_bill_btn' emed_tid='rad_bill_trns_exp_sav'>
                  <Box component={'img'} src={ImagePaths.ExportIcon.default} height={'2vw'} width={'2vw'} />
                </Button>
              </Tooltip> */}
            </Box>
          </Box>
          <Box component={'div'} className='rad_bill_trns_content_card'>
            <DataGrid
              sx={{ backgroundColor: Colors.white }}
              columns={columns}
              rows={this.state.savedBillsData}
              getRowId={(row) => row['sno']}
              page={this.state.page}
              pageSize={this.state.pageSize}
              hideFooterSelectedRowCount
              localeText={{
                toolbarColumns: "",
                toolbarDensity: "",
                toolbarExport: "",
                toolbarFilters: "",
                toolbarExportPrint: ""
              }}
              headerHeight={40}
              components={{
                Toolbar: this.gridToolBar,
                NoRowsOverlay: () => (
                  <Box className='eMed_conf_nodata'>
                    {'No Records To Be Shown'}
                  </Box>
                )
              }}
              rowsPerPageOptions={[10, 20, 30]}
              disableSelectionOnClick
              pagination
              onPageChange={(newPage) => { this.setState({ page: newPage }) }}
              onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
              loading={this.state.isLoader}
            />
          </Box>
        </Box>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.deletePopup ? <DeletePopup
          DeletTitle={`Are you sure you want to delete?`}
          deleteAlertPopupClose={this.popupClose.bind(this)}
          removeData={this.deleteSavedBillData.bind(this)}
          disable={this.state.removeData}
        /> : null}
        <Drawer
          anchor={'right'}
          open={this.state.FilterOpen}
          ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
        >
          <RadBillingFilter PageName={"SavedBills"} FilterDatas={this.state.FilterDatas} CloseFilter={this.ClosePopUp.bind(this)} FilteredData={this.renderFilter.bind(this)} ClearData={this.clearFilter.bind(this)} callDocApi={true} />
        </Drawer>
      </Box>
    )
  }
}
